(() => {
  const waitForWidget = (cb, tries = 0) => {
    if (typeof carouselInlineWidget === 'function') {
      cb();
      return;
    }
    if (tries > 50) return;
    setTimeout(() => waitForWidget(cb, tries + 1), 100);
  };

  const init = (container) => {
    if (!container || container.dataset.rioInit === '1') return;

    const storeId = container.dataset.storeId;
    if (!storeId || !container.id) return;

    container.dataset.rioInit = '1';

    new carouselInlineWidget(container.id, {
      store: storeId,
      sku: '',
      lang: 'en',
      carousel_type: 'topHeader',
      styles_carousel: 'CarouselWidget--topHeader--withcards',
      options: {
        general: {
          review_type: 'company, product',
          min_reviews: '1',
          max_reviews: '20',
          address_format: 'CITY, COUNTRY',
          enable_auto_scroll: 10000,
          enable_pause_button: true,
          enable_sorting: false,
        },
        header: {
          enable_overall_stars: true,
          rating_decimal_places: 2,
        },
        reviews: {
          enable_customer_name: true,
          enable_customer_location: true,
          enable_verified_badge: true,
          enable_subscriber_badge: false,
          enable_recommends_badge: false,
          enable_photos: false,
          enable_videos: false,
          enable_review_date: false,
          disable_same_customer: true,
          min_review_percent: 4,
          third_party_source: false,
          hide_empty_reviews: true,
          enable_product_name: false,
          tags: '',
          branch: '',
          enable_branch_name: false,
        },
        popups: {
          enable_review_popups: false,
          enable_helpful_buttons: false,
          enable_helpful_count: false,
          enable_share_buttons: false,
        },
      },
      translations: {
        verified_customer: 'Verified Customer',
        based_on: 'average',
      },
      styles: {
        '--base-font-size': '16px',
        '--base-maxwidth': '100%',
        '--reviewsio-logo-style': 'var(--logo-normal)',
        '--common-star-color': '#250028',
        '--common-star-disabled-color': 'rgba(37,0,40,0.25)',
        '--medium-star-size': '22px',
        '--small-star-size': '19px',
        '--x-small-star-size': '16px',
        '--x-small-star-display': 'inline-flex',
        '--header-order': '1',
        '--header-width': 'auto',
        '--header-bg-start-color': 'transparent',
        '--header-bg-end-color': 'transparent',
        '--header-padding': '0.5em',
        '--header-border-width': '0px',
        '--header-shadow-size': '0px',
        '--heading-text-color': '#250028',
        '--heading-text-font-weight': '600',
        '--body-text-color': '#250028',
        '--scroll-button-icon-color': '#250028',
        '--scroll-button-bg-color': 'transparent',
        '--scroll-button-border-width': '0px',
        '--badge-icon-color': '#250028',
        '--badge-text-color': '#250028',
        '--item-maximum-columns': '5',
        '--item-background-start-color': '#ffffff',
        '--item-background-end-color': '#ffffff',
        '--item-padding': '1.5em',
        '--item-border-width': '0px',
        '--item-shadow-size': '0px',
      },
    });
  };

  const initAll = () => {
    waitForWidget(() => {
      document.querySelectorAll('[data-reviews-io-carousel]').forEach(init);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  window.addEventListener('load', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
